import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { motion } from "framer-motion";
import { Navigation } from "../components/Navigation";
import { ArticleCard } from "../components/ArticleCard";
import { Logo } from "../components/Logo";
import { fetchArticles, CATEGORY_LABELS } from "../lib/api";

const INTRO = {
  sports: "The stories, the rivalries, and the moments that make the game matter.",
  entertainment: "Live music, film and the culture of performance, up close.",
  culture: "Art, photography and ideas shaping how we see the world.",
  featured: "Our editors' picks. The stories defining this moment at Phusic.",
};

export default function CategoryPage() {
  const { category } = useParams();
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetchArticles({ category })
      .then(setArticles)
      .finally(() => setLoading(false));
  }, [category]);

  const label = CATEGORY_LABELS[category] || category;

  return (
    <div className="min-h-screen bg-ink grain">
      <Navigation />

      <header className="pt-32 pb-12 px-6 lg:px-10 border-b border-white/10">
        <div className="mx-auto max-w-7xl">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <p className="font-body text-xs uppercase tracking-[0.28em] text-crimson mb-4">
              Category
            </p>
            <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-white leading-none">
              {label}
            </h1>
            <p className="mt-5 font-body text-base sm:text-lg text-white/60 max-w-xl">
              {INTRO[category] || "Explore the latest from Phusic."}
            </p>
          </motion.div>
        </div>
      </header>

      <main className="px-6 lg:px-10 py-14">
        <div className="mx-auto max-w-7xl">
          {loading ? (
            <p className="font-body text-white/50">Loading stories…</p>
          ) : articles.length === 0 ? (
            <p data-testid="empty-state" className="font-body text-white/50">
              No stories here yet.
            </p>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {articles.map((a, i) => (
                <ArticleCard key={a.slug} article={a} index={i} />
              ))}
            </div>
          )}
        </div>
      </main>

      <footer className="border-t border-white/10 px-6 lg:px-10 py-10 flex items-center justify-between">
        <Logo size="text-3xl" />
        <span className="font-body text-xs text-white/40 uppercase tracking-[0.2em]">
          © 2026 Phusic
        </span>
      </footer>
    </div>
  );
}
